module.exports = __webpack_public_path__ + "img/avatar_ye.a9886c22.png";